export default "__VITE_ASSET__BGR1pJPx__"